import usersCreateComponent from './users.create.component';

let usersCreateModule = angular.module('userscreate', [
  ])

  .component('userscreate', usersCreateComponent)

  .name;

export default usersCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/users/create/index.js